export default __webpack_public_path__ + "static/media/55.5355b9f0.jpg";